import { workspaceAccessConfig } from '@/config/workspace-access';
import type { StorageTier } from '@/lib/storage/storage-paths';

export type UploadAudience = 'paid' | 'free';

export const IMAGE_INPUT_MIN_WIDTH = 128;
export const IMAGE_INPUT_MIN_HEIGHT = 128;
export const FREE_IMAGE_INPUT_MAX_BYTES = 5 * 1024 * 1024;
export const PAID_IMAGE_INPUT_MAX_BYTES = 20 * 1024 * 1024;

export function resolveImageInputMaxBytesForStorageTier(tier: StorageTier) {
  return !workspaceAccessConfig.paidEntitlementsEnabled || tier === 'premium'
    ? PAID_IMAGE_INPUT_MAX_BYTES
    : FREE_IMAGE_INPUT_MAX_BYTES;
}
